<button id="historyModalBtn" data-toggle="modal" data-target="#deviceHistory_modal" [hidden]="true">
  History Modal
</button>
<!--Device Detail start-->
<div data-keyboard="false" data-backdrop="static" id="deviceHistory_modal" class="modal fade">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content bd-0 bg-transparent overflow-hidden">
      <div class="modal-body p-0">
        <div class="row no-gutters">
          <div class="col-12">
            <span class="pull-right closeBtn" id="closeHistoryModal" data-dismiss="modal" (click)="onClose()">
              <i class="fa fa-times" aria-hidden="true"></i>
            </span>
            <div class="modal-box p-3 mt-4">
              <div class="reply-header">
                <h5>
                  Device History
                </h5>
              </div>
              <div class="login-content user-modal mt-20 device-history">
                <div class="row mb-3">
                  <div class="col-sm-4">
                    <i class="fa fa-bolt-lightning history-icons"></i>
                    <div class="d-inline-block">
                      <span> Campaign Name</span><br>
                      <span class="bold">{{campaignName}}</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <i class="fa fa-microchip history-icons"></i>
                    <div class="d-inline-block">
                      <span> Serial Number</span><br>
                      <span class="bold">{{device.serialNumber}}</span>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <i class="fa fa-repeat history-icons"></i>
                    <div class="d-inline-block">
                      <span>Trigger Count</span><br>
                      <span class="bold">{{deviceHistory.length}}</span>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <button class="btn btn-icon" ngbTooltip="Export CSV" placement="top"
                      [disabled]="!deviceHistory.length" (click)="exportActivityCSV()">
                      <i class="fa fa-cloud-download"></i>
                    </button>
                  </div>
                </div>
                <hr>
                  @if (deviceHistoryView.length) {
                    <div class="list-items scrollable-modal-body">
                      @for (data of deviceHistoryView; track data) {
                        <div>
                          <div class="row no-gutters">
                            <div class="col-sm-12 activity">
                              <!-- Stage Info -->
                              <div class="info">
                                <div class="stage d-inline-block" style="width: 29%;">
                                  <span class="badge badge-light">Stage - {{data.stage}}</span>
                                </div>
                                <div class="total-time d-inline-block text-right" style="width: 69%;">
                                  <span class="author" ngbTooltip="Scheduled By">
                                    <i class="fa fa-user pr-1" aria-hidden="true"></i>
                                    <span>{{data.scheduledBy}}</span>
                                  </span>
                                  <span class="time ml-2" ngbTooltip="Processing Time">
                                    <i class="fa fa-clock-o pr-1" aria-hidden="true"></i>
                                    @if (data.totalTime) {
                                      <span>{{data.totalTime | secondsToHms: 'milliseconds'}}</span>
                                    }
                                    @if (!data.totalTime) {
                                      <span>------</span>
                                    }
                                  </span>
                                </div>
                              </div>
                              <!-- Timeline start -->
                              <ul class="timeline">
                                <!-- Initial stage where status is SCHEDULED -->
                                <li style="z-index: 5;"
                                  [class.scheduled]="data.status==='RETRY' || data.status==='SYSTEM_RETRY' || data.status==='SCHEDULED'"
                                  [class.commandSent]="data.status==='COMMAND_SENT'"
                                  [class.inProgress]="data.status==='PROGRESS'"
                                  [class.downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                                  [class.success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                                  [class.cancelled]="data.status==='CANCELLED'"
                                  [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                                  <div class="status">
                                    @if (data.status==='RETRY' || data.status==='SYSTEM_RETRY') {
                                      <span> Retry </span>
                                    }
                                    @if (data.status!=='RETRY' && data.status!=='SYSTEM_RETRY') {
                                      <span> Scheduled </span>
                                    }
                                  </div>
                                  <div class="status-dot"></div>
                                  <div class="timestamp">
                                    <span class="date text-muted">{{data.scheduleAt | date: dateFormat}}</span>
                                  </div>
                                </li>
                                <!-- Next stage where status is COMMAND_SENT -->
                                <li style="z-index: 4;" [class.commandSent]="data.status==='COMMAND_SENT'"
                                  [class.inProgress]="data.status==='PROGRESS'"
                                  [class.downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                                  [class.success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                                  [class.cancelled]="data.status==='CANCELLED'"
                                  [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                                  <div class="status">
                                    <span> Command Sent </span>
                                  </div>
                                  <div class="status-dot"></div>
                                  @if (data.commandSentAt) {
                                    <div class="timestamp">
                                      <span class="date text-muted">{{data.commandSentAt | date: dateFormat}}</span>
                                    </div>
                                  }
                                </li>
                                <!-- The stage where the device status is PROGRESS -->
                                <li style="z-index: 3;" [class.inProgress]="data.status==='PROGRESS'"
                                  [class.downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                                  [class.success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                                  [class.cancelled]="data.status==='CANCELLED'"
                                  [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                                  <div class="status">
                                    <span> In Progress </span>
                                  </div>
                                  <div class="status-dot"></div>
                                  @if (data.progressAt) {
                                    <div class="timestamp">
                                      <span class="date text-muted">{{data.progressAt | date: dateFormat}}</span>
                                    </div>
                                  }
                                </li>
                                <!-- Stage where status is DOWNLOAD_SUCCESS -->
                                <li style="z-index: 2;"
                                  [class.downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                                  [class.success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                                  [class.cancelled]="data.status==='CANCELLED'"
                                  [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                                  <div class="status">
                                    <span> Download Success </span>
                                  </div>
                                  <div class="status-dot"></div>
                                  @if (data.downloadSuccessAt) {
                                    <div class="timestamp">
                                      <span class="date text-muted">{{data.downloadSuccessAt | date: dateFormat}}</span>
                                    </div>
                                  }
                                </li>
                                <!--
                                Final stage where status is either SUCCESS, FAILED or CANCELLED.
                                This stage defines the class and color of all the above status.
                                -->
                                <li style="z-index: 1;"
                                  [class.success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                                  [class.installSuccess]="data.status==='INSTALL_SUCCESS'"
                                  [class.cancelled]="data.status==='CANCELLED'"
                                  [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                                  <div class="status">
                                    <span> {{ data.status==='INSTALL_FAILED' ? 'Install Failed' : 'Install Success'}} </span>
                                  </div>
                                  <div class="status-dot"
                                    [class.hover-enabled]="data.status==='INSTALL_SUCCESS' || data.status==='INSTALL_FAILED'  || data.status==='TOO_MANY_ATTEMPT'"
                                    [ngbTooltip]="tooltipContent(data)">
                                  </div>
                                  @if (data.installSuccessAt && data.status==='INSTALL_SUCCESS') {
                                    <div class="timestamp">
                                      <span class="date text-muted">{{data.installSuccessAt | date: dateFormat}}</span>
                                    </div>
                                  }
                                  @if (data.installFailedAt && data.status==='INSTALL_FAILED') {
                                    <div class="timestamp">
                                      <span class="date text-muted">{{data.installFailedAt | date: dateFormat}}</span>
                                    </div>
                                  }
                                </li>
                                <li style="z-index: 0;" [class.success]="data.status==='SUCCESS'"
                                  [class.cancelled]="data.status==='CANCELLED'"
                                  [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT'">
                                  <div class="status">
                                    @if (data.status==='SUCCESS') {
                                      <span> Success </span>
                                    }
                                    @if (data.status==='CANCELLED') {
                                      <span> Cancelled </span>
                                    }
                                    <!--<span *ngIf="data.status==='CANCELLED'"> {{data.cancelledBy}} </span>-->
                                    @if (data.status==='FAILED') {
                                      <span> Failed </span>
                                    }
                                    @if (data.status==='TOO_MANY_ATTEMPT') {
                                      <span> Too Many Attempts </span>
                                    }
                                    @if (data.status!=='SUCCESS' && data.status!=='CANCELLED' && data.status!=='FAILED' && data.status!=='TOO_MANY_ATTEMPT') {
                                      <span
                                      >Success</span>
                                    }
                                  </div>
                                  <div class="status-dot"></div>
                                  @if (data.completedAt) {
                                    <div class="timestamp">
                                      <span class="date bold">{{data.completedAt | date: dateFormat}}</span>
                                      @if (data.status==='CANCELLED' && data.cancelledBy) {
                                        <span class="date bold d-block">
                                          <span class="author" ngbTooltip="Cancelled By">
                                            <i class="fa fa-user pr-1" aria-hidden="true"></i>
                                            {{data.cancelledBy}}
                                          </span>
                                        </span>
                                      }
                                    </div>
                                  }
                                </li>
                              </ul>
                              <!-- Timeline End -->
                            </div>
                            <!-- Display Error or Remark if it is present -->
                            @if (data.errorCode || data.remark) {
                              <div class="col-sm-12 error ml-4">
                                @if (data.errorCode) {
                                  <label class="m-0">
                                    Error: <span
                                  class="text-danger">{{failStatus[data.errorCode]?failStatus[data.errorCode]:data.errorCode}}</span>
                                </label>
                                }@if (data.errorCode) {
                                <br>
                                }
                                @if (data.remark) {
                                  <label class="m-0">
                                    Remark: <span class="text-danger">{{data.remark}}</span>
                                  </label>
                                }
                              </div>
                            }
                          </div>
                          <hr>
                          </div>
                        }
                        @if (loadmore) {
                          <div class="my-3 text-center text-primary" style="font-size: 14px;">
                            <span (click)="loadMoreActivity()" class="cursor-pointer">load more</span>
                          </div>
                        }
                      </div>
                    }
                    @if (!deviceHistoryView.length && !isLoading) {
                      <div class="text-center mb-4">
                        <span class="bold">No History.</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Device Detail end-->